module.exports = __webpack_public_path__ + "img/493992a.jpg";